import { surveyButtonDestinations, surveyTargetingStrategies } from "./survey.constants";

export function surveyButtonDestinationLabel(deepLinkUrl) {
  const destination = surveyButtonDestinations.find((item) => item.value === deepLinkUrl);
  return destination ? destination.label : "Not configured";
}

export function surveyTargetingStrategy(value) {
  return surveyTargetingStrategies.find((strategy) => strategy.value === Number(value)) || surveyTargetingStrategies[0];
}

export function moveItem(items, from, to) {
  if (to < 0 || to >= items.length) return items;
  const next = items.slice();
  const item = next.splice(from, 1)[0];
  next.splice(to, 0, item);
  return next;
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

export function rewardLabel(reward) {
  return reward && reward.type === "flash_credits"
    ? `${reward.amount} Flash Credits`
    : "No reward";
}

export function answerLabel(question) {
  if (question.answer === null || typeof question.answer === "undefined") return "Skipped";
  if (question.type === "number") return `${question.answer}${question.unit ? ` ${question.unit}` : ""}`;
  if (question.type === "rating") {
    const labels = [question.minLabel, question.maxLabel].filter(Boolean).join(" → ");
    return `${question.answer} / 5 (${question.ratingStyle})${labels ? ` · ${labels}` : ""}`;
  }
  if (question.type === "single_choice" || question.type === "multi_choice") {
    const values = Array.isArray(question.answer) ? question.answer : [question.answer];
    const labels = values.map((selected) => {
      const option = (question.options || []).find(
        (item) => String(item.id) === String(selected) || item.value === selected,
      );
      return option ? option.label : String(selected);
    });
    if (question.additionalText) labels.push(question.additionalText);
    return labels.join(" — ");
  }
  return String(question.answer);
}
